const THOUSAND = 1000;
const MILLION = 1_000_000;
const TENTHS = 10;

type FormatCompactNumberOptions = {
  /**
   * Decimal places kept on the thousands (e.g. 1 for EUR prices: 12 345 → “12,3 k”).
   * Defaults to 0 — whole thousands.
   */
  thousandsDecimals?: number;
};

/**
 * Compact numeric format for the dashboard saved-filters card: 245 000 → “245 k”,
 * 1 234 567 → “1,2 M”, 983 → “983”. Locale-aware digits come from the caller.
 */
export function formatCompactNumber(
  value: number,
  formatNumber: (value: number, decimals?: number) => string | null,
  options?: FormatCompactNumberOptions
): string {
  const abs = Math.abs(value);
  if (abs >= MILLION) {
    const millions = Math.round((value / MILLION) * TENTHS) / TENTHS;
    return `${formatNumber(millions, Number.isInteger(millions) ? 0 : 1) ?? millions} M`;
  }
  if (abs >= THOUSAND) {
    const decimals = options?.thousandsDecimals ?? 0;
    const factor = TENTHS ** decimals;
    const thousands = Math.round((value / THOUSAND) * factor) / factor;
    return `${formatNumber(thousands, decimals) ?? thousands} k`;
  }
  return formatNumber(value) ?? String(value);
}
